module.exports = {
      id: "ic-other-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-other-usage",
      toString: function () {
        return this.url;
      }
    }